import { z } from 'zod'
import { oc } from '@orpc/contract'
import { pageRequestSchema } from './duplicate-review.contract'
import { mergeStatusSchema } from './patient-merge-shared.contract'

/**
 * Super-admin procedures for merged records (PD-1986): the Merged patients list, Restore, and the
 * retention setting. Plain fields at the boundary — never FHIR resources.
 */

/** Every merge, newest first, in any state (merging, merged, restoring, restored, deleted). */
export const mergedPatientList = oc
  .route({ method: 'POST', path: '/v2/patient-merge/merged/list' })
  .input(z.object({ page: pageRequestSchema }))
  .output(
    z.object({
      page: pageRequestSchema.extend({
        size: z.number().int().min(0),
        total: z.number().int().min(0),
        truncated: z.boolean().optional(),
        incompleteTotal: z.boolean().optional(),
      }),
      data: z.array(mergeStatusSchema),
    }),
  )

/** Starts undoing a finished merge; the result is the merge, now `restoring`. */
export const patientMergeRestore = oc
  .route({ method: 'POST', path: '/v2/patient-merge/merges/{mergeId}/restore' })
  .input(z.object({ mergeId: z.string().min(1) }))
  .output(mergeStatusSchema)

const mergeSettingsSchema = z.object({
  /** Days a merged record is kept (restorable) before it is deleted. */
  retentionDays: z.number().int().min(1).max(365),
})

export const patientMergeSettingsGet = oc
  .route({ method: 'GET', path: '/v2/patient-merge/settings' })
  .output(mergeSettingsSchema)

export const patientMergeSettingsSet = oc
  .route({ method: 'PUT', path: '/v2/patient-merge/settings' })
  .input(mergeSettingsSchema)
  .output(mergeSettingsSchema)
